import Vue from 'vue'
import global from './utils/global'
import { fetchWxSign } from './api/wx'
import { transferAdminMedia2Url } from './api/admin'
import { transferMedia2Url } from './api/upload'

const dt = '艾邦360'
const dd = '艾邦360，企业的朋友圈'
const di = 'https://ww1.sinaimg.cn/large/005YhI8igy1fvp4jszet1j305k05kaa5'

Vue.prototype.wxConfig = function(apiList) {
  const that = this
  return new Promise(async function(resolve, reject) {
    const wx = Vue.wechat
    const currentUrl = global.domain + that.$route.fullPath
    const signUrl = currentUrl
    const jsApiList = ['checkJsApi'].concat(apiList)
    try {
      const { data } = await fetchWxSign(signUrl)
      if (data.message === 'ok') {
        wx.config({
          debug: false,
          appId: global.appid,
          timestamp: data.rst.timestamp,
          nonceStr: data.rst.nonceStr,
          signature: data.rst.signature,
          jsApiList: jsApiList
        })
        resolve(data.rst)
      }
    } catch (e) {
      reject(e)
    }
  })
}

Vue.prototype.wxChooseImage = function(imgNum) {
  return new Promise(function(resolve, reject) {
    const wx = Vue.wechat
    wx.chooseImage({
      count: imgNum,
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      success: function(res) {
        resolve({ 'rst': res.localIds })
      },
      cancel: function(error) {
        reject(error)
      }
    })
  })
}

Vue.prototype.wxUploadImage = function(image) {
  return new Promise(function(resolve, reject) {
    const wx = Vue.wechat
    wx.uploadImage({
      localId: image,
      isShowProgressTips: 0,
      success: function(res) {
        resolve({ 'rst': res.serverId })
      },
      fail: function(error) {
        reject(error)
      }
    })
  })
}

Vue.prototype.wxUploadImage2Url = function(image) {
  return new Promise(function(resolve, reject) {
    const wx = Vue.wechat
    wx.uploadImage({
      localId: image,
      isShowProgressTips: 0,
      success: async function(res) {
        try {
          const { data } = await transferMedia2Url(res.serverId)
          if (data.message === 'ok') {
            resolve({ 'rst': data.rst.url })
          }
        } catch (e) {
          reject(e)
        }
      },
      fail: function(error) {
        reject(error)
      }
    })
  })
}

Vue.prototype.wxAdminUploadImage2Url = function(image) {
  return new Promise(function(resolve, reject) {
    const wx = Vue.wechat
    wx.uploadImage({
      localId: image,
      isShowProgressTips: 0,
      success: async function(res) {
        try {
          const { data } = await transferAdminMedia2Url(res.serverId)
          if (data.message === 'ok') {
            resolve({ 'rst': data.rst.url })
          }
        } catch (e) {
          reject(e)
        }
      },
      fail: function(error) {
        reject(error)
      }
    })
  })
}

Vue.prototype.wxShare = function(
  title = dt, desc = dd, imgUrl = di, timeLineTitle = null, path = null) {
  if (timeLineTitle === null || timeLineTitle === '') {
    timeLineTitle = title
  }
  if (!imgUrl) {
    imgUrl = di
  }
  const wx = Vue.wechat
  let sharePath = path
  if (!path) {
    sharePath = this.$route.fullPath
  }
  const currentUrl = encodeURI(global.domain + sharePath)
  const wxTicket = this.wxConfig([
    'onMenuShareTimeline',
    'onMenuShareAppMessage'])
  desc = desc.replace(/<[^>]+>/g, '')
  desc = desc.trim() !== '' ? desc : '艾邦360，企业的朋友圈'
  // uploadLog(
  //   'wxShare||' + title + '||' + desc + '||' + imgUrl + '||' + timeLineTitle +
  //   '||' +
  //   currentUrl)
  wx.ready(() => {
    // 分享给朋友
    // alert('6:' + title + ';' + timeLineTitle)
    wx.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: currentUrl,
      imgUrl: imgUrl,
      success: function(res) {
        // alert('已分享')
      }
    })
    // 分享到朋友圈
    wx.onMenuShareTimeline({
      title: timeLineTitle,
      link: currentUrl,
      imgUrl: imgUrl,
      success: function(res) {
        // alert('已分享')
      }
    })
  })
  return wxTicket
}



// WEBPACK FOOTER //
// ./src/wx_share.js